<template>
    <div class="register">
        <div class="mask" v-show="isEnd">
            <div class="toast">分享活动已结束，下期活动见～</div>
            <div class="btn" @click="openZlink">点我下载图虫APP</div>
        </div>
        <div class="mask" v-show="step === 'finish' && !err">
            <div class="toast">注册成功！</div>
            <div class="toast">下载图虫APP上传图片/视频吧</div>
            <div class="btn" @click="openZlink">点我下载图虫APP</div>
        </div>
        <div class="title">
            <div class="logo"></div>
            <div class="content" v-if="step === 'phone'">用户注册</div>
            <div class="content" v-else>输入验证码</div>
        </div>
        <div class="tip" v-if="step === 'phone'">
            <div
                class="check"
                :class="{ check: true, action: check }"
                @click="checkUserRule"
            >
                <svg
                    width="15"
                    height="15"
                    viewBox="-3 -4 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 2.54398L3.16136 4.75L7 1"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            我已阅读并同意
            <a href="https://tuchong.com/info/term?enter_from=page_login_onekey"
                >用户协议</a
            >
            和
            <a
                href="https://tuchong.com/info/policy?enter_from=page_login_onekey"
                >隐私政策</a
            >
        </div>
        <div class="tip" v-else>
            短信已发送: {{ phoneNumber }} ｜
            <span @click.stop="reset">重新输入手机号</span>
        </div>
        <div class="input" v-if="step === 'phone'">
            <input
                id="phone"
                type="text"
                v-model="phoneNumber"
                placeholder="请输入手机号"
                maxlength="11"
                autocomplete="off"
            />
            <div v-show="phoneNumber" class="remove" @click="clearPhone"></div>
        </div>
        <div class="input" v-else>
            <input
                id="phone"
                type="text"
                v-model="captcha"
                placeholder="请输入验证码"
                maxlength="11"
                autocomplete="off"
            />
            <div class="resend" @click="sendCaptcha">
                {{ countdown > 0 ? `| ${countdown}` : "重新发送" }}
            </div>
        </div>
        <div class="err">{{ err }}</div>
        <div
            v-if="step === 'phone'"
            class="button"
            :style="{
                'background-color':
                    phoneNumber.length === 11 ? '#fd3670' : '#c6c6c6',
            }"
            @click="sendCaptcha"
        >
            获取短信验证码
        </div>
        <div
            v-else
            class="button"
            :style="{
                'background-color':
                    captcha.length === 6 ? '#fd3670' : '#c6c6c6',
            }"
            @click="register"
        >
            注册
        </div>
    </div>
</template>


<script>
export default {
    layout: 'notabbar',
    head() {
        return {
            title: '用户注册',
            script: [
                // 页面适配 hotcss.js
                {
                    src: 'https://static-prod.ituchong.com/tc-common-fe-static/others/tuchong-wap/content-image/202006/72b51ada79ce3e200b482dbe103945c3.js',
                },
            ],
        };
    },
    data() {
        return {
            check: false,
            err: '',
            isEnd: false,
            step: 'phone',
            countdown: 0,
            captcha: '',
            phoneNumber: '',
            invitation_code: '',
        };
    },
    mounted() {
        // 活动是否结束
        this.$axios
            .get('/tuchonggapi/misc/bole/get-activity-status')
            .then((data) => {
                if (data.status === 0) {
                    this.isEnd = true;
                }
            });
        // 从网址上获取分享码

        function queryLocation(href) {
            const back = {};
            const queryString = href.split('?');
            if (queryString.length === 2) {
                const queryList = queryString[1].split('&');
                queryList.map((item) => {
                    const queryItem = item.split('=');
                    queryItem.length === 2
                        && (back[queryItem[0]] = queryItem[1]);
                });
            }
            return back;
        }

        const { invitation_code } = queryLocation(window.location.href);
        this.invitation_code = invitation_code;
    },
    methods: {
        clearPhone() {
            this.phoneNumber = '';
        },
        clearCaptcha() {
            this.captcha = '';
        },
        reset() {
            this.err = '';
            this.phoneNumber = '';
            this.captcha = '';
            this.step = 'phone';
        },
        startCountdown() {
            setTimeout(() => {
                this.countdown--;
                if (this.countdown > 0) {
                    this.startCountdown();
                }
            }, 1000);
        },
        sendCaptcha() {
            if (this.phoneNumber.length !== 11) {
                return;
            }
            if (this.check === false) {
                this.$toastV2('请勾选相关协议');
                return;
            }
            this.err = '';
            if (this.countdown <= 0) {
                this.$axios
                    .post(
                        '/tuchongapi/captcha/sms/universal',
                        {
                            scene: 'login',
                            mobile_number: this.phoneNumber,
                        },
                        { hideToast: true },
                    )
                    .then((data) => {
                        if (data.result === 'SUCCESS') {
                            this.step = 'captcha';
                            this.countdown = 60;
                            this.startCountdown();
                        }
                    })
                    .catch(({ data }) => {
                        this.err = data.message;
                    });
            } else {
                this.err = `请${this.countdown}秒后再试`;
            }
        },
        openZlink() {
            const lastEncodeUrl = `https://protocol.ituchong.com/app-download?scheme=${encodeURIComponent(
                'tuchong://?type=home_switch&name=推荐',
            )}`;
            window.location.href = lastEncodeUrl;
        },
        checkUserRule() {
            this.check = !this.check;
        },
        register() {
            if (this.captcha.length !== 6) {
                return;
            }
            this.err = '';
            this.$axios
                .post(
                    '/tuchongapi/accounts/login-mobile-bole',
                    {
                        captcha: this.captcha,
                        mobile_number: this.phoneNumber,
                    },
                    { hideToast: true },
                )
                .then((data) => {
                    if (data.result === 'SUCCESS') {
                        // 发送确认接口
                        this.$axios
                            .get(
                                '/tuchonggapi/misc/bole/invitee/bole-register',
                                {
                                    params: {
                                        user_id: data.identity,
                                        phone: this.phoneNumber,
                                        invitation_code: this.invitation_code,
                                    },
                                },
                                { hideToast: true },
                            )
                            .then((data) => {
                                if (data.status === 1) {
                                    this.step = 'finish';
                                } else {
                                    this.err = data.message;
                                }
                            })
                            .catch(({ data }) => {
                                this.err = data.message;
                            });
                    }
                })
                .catch(({ data }) => {
                    this.err = data.message;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../styles/px2rem.scss";
// 设计稿宽度
$designWidth: 375;

.register {
    margin: 0 px2rem(30);
    color: #222;
    .title {
        margin-top: px2rem(75);
        display: flex;
        align-items: center;
        .logo {
            margin-right: px2rem(13);
            width: px2rem(24);
            height: px2rem(20);
            background-size: 100%;
            background-repeat: no-repeat;
            background-image: url(https://static-prod.ituchong.com/tc-common-fe-static/others/tuchong-wap/content-image/202107/20327cca92d3543bd395592fabc43b8a.png);
        }
        .content {
            font-size: px2rem(25);
        }
    }

    .tip {
        display: flex;
        margin-top: px2rem(12);
        font-size: px2rem(14);
        color: #9b9b9b;
        > a,
        > span {
            color: rgb(52, 116, 246);
        }

        .check {
            border-radius: 9999999px;
            background-color: #fff;
            width: px2rem(15);
            height: px2rem(15);
            display: flex;
            justify-items: center;
            align-items: center;
            margin-right: px2rem(5);
            border: px2rem(2) solid #9b9b9b;
        }

        .action {
            background-color: #fd3670;
            border: none;
        }
    }

    #phone {
        margin-top: px2rem(24);
        background: #f8f8f8;
        padding: px2rem(14);
        width: 100%;
        font-size: 16px;
        outline: none;
    }
    .input {
        position: relative;
        .remove {
            background-image: url(https://static-prod.ituchong.com/tc-common-fe-static/others/tuchong-wap/content-image/202107/a82cad3605d8f67403f6b4737e81f81c.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: absolute;
            width: px2rem(14);
            height: px2rem(14);
            right: px2rem(16);
            bottom: px2rem(16);
        }
        .resend {
            position: absolute;
            width: px2rem(60);
            height: px2rem(16);
            line-height: px2rem(16);
            right: px2rem(16);
            bottom: px2rem(14);
            font-size: px2rem(13);
            color: #999;
            text-align: right;
        }
    }
    .button {
        padding: px2rem(12);
        font-size: px2rem(16);
        text-align: center;
        color: #fff;
        border-radius: 9999999px;
        margin-top: px2rem(24);
    }

    .mask {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 5;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .toast {
            margin-top: px2rem(25);
            text-align: center;
        }

        .btn {
            margin-top: px2rem(15);
            margin-bottom: px2rem(180);
            padding: px2rem(13) px2rem(30);
            background-color: #fd3670;
            border-radius: px2rem(14);
            font-size: px2rem(14);
        }
    }
    .err {
        margin-top: px2rem(10);
        color: #fd3670;
        font-size: px2rem(14);
    }
}
</style>
